import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * AppConfigContext — espone la config PUBBLICA (nessun segreto).
 * Il frontend la usa per: URL del sito ristorante nell'header, toggle
 * sommelier, toggle denominazioni sulla mappa, ecc.
 *
 * Fetch una sola volta al mount dell'app; auto-refresh silenzioso ogni
 * 10 minuti (utile se l'admin cambia una toggle mentre l'utente è online).
 */
const AppConfigContext = createContext({ publicCfg: null, reload: () => {} });

export function AppConfigProvider({ children }) {
    const [publicCfg, setPublicCfg] = useState(null);

    const reload = () => {
        api.get("/config/public")
            .then(({ data }) => setPublicCfg(data))
            .catch(() => setPublicCfg({}));
    };

    useEffect(() => {
        reload();
        const t = setInterval(reload, 10 * 60 * 1000);
        return () => clearInterval(t);
    }, []);

    return (
        <AppConfigContext.Provider value={{ publicCfg, reload }}>
            {children}
        </AppConfigContext.Provider>
    );
}

export function useAppConfig() {
    return useContext(AppConfigContext);
}
